import { PropertyType } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteResults.AdGeo.PropertyType */
export { PropertyType };
import { SpaceUse } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.AdGeo.SpaceUse */
export { SpaceUse };
import { ListingType } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteResults.AdGeo.ListingType */
export { ListingType };
